import React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import { IProductFile } from "../../../../api/Admin/dbProductFilesApi";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";

export interface IFileUserScopePivot {
  userName: string;
  order: string;
  program: string;
  download: boolean;
  activateSupport: boolean;
  activateFull: boolean;
}

export interface IProductFileUsersDialogProps {
  open: boolean;
  file: IProductFile | undefined;
  scopes: IFileUserScopePivot[];
  handleCancel: () => void;
}

const AdminProductFileUsersDialog: React.FC<IProductFileUsersDialogProps> = ({
  open,
  file,
  scopes,
  handleCancel,
}) => {

  const getFileName = (file: string) => {
    if (file) {
      return file.substring(file.lastIndexOf("/") + 1);
    }
    return file;
  };

  const columns: GridColDef[] = [
    { field: "userName", headerName: "User Name", width: 200 },
    { field: "order", headerName: "Order", width: 100 },
    { field: "program", headerName: "Program", width: 300 },
    {
      field: "download",
      headerName: "Download",
      width: 120,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? (
          <CheckIcon sx={{ width: "24px", height: "24px" }}></CheckIcon>
        ) : (
          <div></div>
        );
      },
    },
    {
      field: "activateSupport",
      headerName: "Support",
      width: 120,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? (
          <CheckIcon sx={{ width: "24px", height: "24px" }}></CheckIcon>
        ) : (
          <div></div>
        );
      },
    },
    {
      field: "activateFull",
      headerName: "Full License",
      width: 120,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? (
          <CheckIcon sx={{ width: "24px", height: "24px" }}></CheckIcon>
        ) : (
          <div></div>
        );
      },
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={() => handleCancel()}
      aria-labelledby="new project"
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title">
        <Typography variant="h6">{getFileName(file!.url)}</Typography>
      </DialogTitle>
      <DialogContent>
        <div style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={scopes}
            columns={columns}
            getRowId={(row, index) => `${row.userName}-${row.order}-${row.program}-${index}`}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 25 }
              },
              grouping: {
                model: [{ field: 'userName' }]
              }
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 }
              }
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            checkboxSelection={false}
            disableRowSelectionOnClick
          />
        </div>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          style={{ marginTop: 16 }}
        >
          <Button onClick={() => handleCancel()} type="reset">
            Close
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AdminProductFileUsersDialog;
